"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_redux_1 = require("react-redux");
var react_1 = require("@heroui/react");
var reward_node_1 = __importDefault(require("../reward_node"));
var react_2 = require("react");
var challenge_1 = require("../../../../../../../reducers/slices/challenge/challenge");
var challengeEditorContext_1 = require("../../../../../../../contexts/challengeEditorContext");
var StatisticRewardNode = function (props) {
    var isReadOnly = (0, challengeEditorContext_1.useChallengeReadOnly)();
    var data = props.data;
    var dispatch = (0, react_redux_1.useDispatch)();
    var setConfigData = function (config) {
        dispatch((0, challenge_1.setNode)(__assign(__assign({}, props), { data: __assign(__assign({}, data), { config: config }) })));
    };
    var configurationComponent = function () { return ((0, jsx_runtime_1.jsx)("div", { className: "flex flex-col gap-2", children: (0, jsx_runtime_1.jsxs)(react_1.TextField, { isReadOnly: isReadOnly, value: data.config.value, onChange: function (value) { return setConfigData(__assign(__assign({}, data.config), { value: value })); }, children: [(0, jsx_runtime_1.jsx)(react_1.Label, { children: "Value" }), (0, jsx_runtime_1.jsx)(react_1.Input, { max: 999999999, maxLength: 20 })] }) })); };
    return (0, jsx_runtime_1.jsx)(reward_node_1.default, __assign({ data: data }, props, { configurationComponent: configurationComponent }));
};
exports.default = (0, react_2.memo)(StatisticRewardNode);
